import { render } from "./FluidsTestTab.vue?vue&type=template&id=b57bcf4c&scoped=true"
import script from "./FluidsTestTab.vue?vue&type=script&lang=js"
export * from "./FluidsTestTab.vue?vue&type=script&lang=js"

import "./FluidsTestTab.vue?vue&type=style&index=0&id=b57bcf4c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b57bcf4c"]])

export default __exports__